/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const useCredId = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let credId = urlParams.get("credId");
  let draft = urlParams.get("published");
  if (credId) {
    credId = String(credId).trim();
  }
  return {
    credId,
    draft,
  };
};
